export const AGGREGATE_FIELDS = 'AGGREGATE_FIELDS';
export const KEY_FIELDS = 'KEY_FIELDS'
export const VARIABLE_FIELDS = 'VARIABLE_FIELDS';
export const PAYMENT_RISK_GRADE = 'PAYMENT_RISK_GRADE'
export const HORIZONTAL = 'HORIZONTAL';
export const ENUMERATED = 'ENUMERATED';
export const NUMERIC = 'NUMERIC';
export const VARIABLE = 'VARIABLE';
export const AGGREGATE = 'AGGREGATE';
export const PAYMENT_RISK_GRADE_DEFAULT_ROW = {
    minScore: '',
    maxScore: '',
    riskGrade: '',
    riskLevel: '',
    gradeDescription: '',
    pd: ''
};